import { apiSlice } from 'api/apiSlice'
import { ProductTemplate } from 'shared/types/ProductTemplate'

export const productTemplateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductTemplate: builder.query<ProductTemplate, string>({
      query: (slug) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/product_templates/${slug}`,
      }),
    }),

    getProductOffers: builder.query<
      { response: unknown },
      { slug: string; countryCode: string; currency: string }
    >({
      query: ({ slug, countryCode, currency }) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/product_templates/${slug}/gmc_offers?countryCode=${countryCode}&currencyCode=${currency}`,
      }),
    }),

    getRecommendations: builder.query<{ productTemplates: ProductTemplate[] }, string>({
      query: (id) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/product_templates/recommended?productTemplateId=${id}&count=24`,
      }),
    }),
  }),
})

export const { useLazyGetProductTemplateQuery, useGetRecommendationsQuery } = productTemplateApi
